<script>
  import { fade } from "svelte/transition"
  import { onMount } from "svelte"
  import { sleep } from "../../../Script/sleep"

  export let notification

  /**
   * @type {String} - this variable stroes notification backgrount colour
   */
  let backgroundColor

  /**
   * @type {String} - this variable stroes notification icon
   */
  let icon

  /**
   * @type {String} - this count shown in notification when it will close
   */
  let countdown = notification.duration / 1000

  /**
   * @type {String} - notification message
   */
  let message = ""

  onMount(async () => {
    try {
      //which type of notification is that will decided here
      switch (notification.type) {
        case "primary":
          backgroundColor = "bg-alert-primary"
          icon = "fa-bell"
          break
        case "secondary":
          backgroundColor = "bg-alert-secondary"
          icon = "fa-lightbulb"
          break
        case "danger":
          backgroundColor = "bg-alert-danger"
          icon = "fa-triangle-exclamation"
          break
        case "warning":
          backgroundColor = "bg-alert-warning"
          icon = "fa-shield-exclamation"
          break
        case "info":
          backgroundColor = "bg-alert-info"
          icon = "fa-circle-exclamation"
          break
        case "success":
          backgroundColor = "bg-alert-success"
          icon = "fa-circle-check"
          break
      }

      if (notification.message.toString().indexOf("%COUNT%") !== -1) {
        do {
          message = notification.message.replace("%COUNT%", countdown)
          await sleep(1000)
          countdown--
        } while (countdown > 0)
      } else {
        message = notification.message
      }
    } catch (error) {
      console.error(error)
    }
  })

  //this line runs "closeNotification" function based on respective notification duration time
  setTimeout(notification.close, notification.duration)
</script>

{#if message != "<strong>Your session has expired.</strong>" && message != "Your session has expired." && message != "Token expired" && message != "<strong>Your session has expired. Please log in again.</strong>"}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div on:click={() => notification.close()} transition:fade={{ duration: 300 }} class="pointer-events-auto flex w-full select-none items-center justify-between gap-4 rounded-md p-3 {backgroundColor}">
    <div class="flex items-center gap-4">
      <div class="text-white">
        <i class="{icon} fa-solid fa-xl" />
      </div>
      <h1 class="break-words text-base font-medium tracking-wide text-white">
        {@html message}
      </h1>
    </div>
    <!-- event forwarding -->
    <!-- <button
    on:click={() => closeNotification(notification.id)}
    on:click|preventDefault
  >
    <Close class="h-5 w-5 fill-white" />
  </button> -->

    <button on:click={() => notification.close()} on:click|preventDefault>
      <div class="text-white">
        <i class="fa-solid fa-xmark fa-lg" />
      </div>
    </button>
  </div>
{/if}
